import React from 'react';
import { CompassIcon, LinkIcon, HeartHandshakeIcon, InstagramIcon } from 'lucide-react';
import { Halo, RuleDot } from './Decor';
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from '../data/site';
const FOUNDER_IMAGE = 'https://cdn.magicpatterns.com/uploads/ur2n2hYoEbvPRyFSQtQeSh/ChatGPT_Image_Jul_30,_2026,_01_29_03_PM.png';
const values = [{
  title: 'Estrategia personalizada',
  body: 'Cada negocio es diferente. Te ayudamos a identificar qué necesitas realmente.',
  icon: <CompassIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-311" data-mp="2xe8y7h7jheui" />
}, {
  title: 'Todo conectado',
  body: 'Estructura, identidad y presencia digital trabajando juntos.',
  icon: <LinkIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-312" data-mp="36enjwhof0vyj" />
}, {
  title: 'Acompañamiento real',
  body: 'Hay una persona detrás de cada proyecto, no solamente una plataforma.',
  icon: <HeartHandshakeIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-313" data-mp="1c0w4t2nbhjvp" />
}];
export function WhyInkova() {
  return <section aria-labelledby="porque-titulo" className="relative overflow-hidden bg-cream" data-id="element-314" data-mp="1ypl138yvw83o">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-16 lg:py-24" data-id="element-315" data-mp="23oo5cr71iaal">
        <div className="grid items-center gap-9 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16" data-id="element-316" data-mp="28m63dmjir53t">
          {/* Composición de la foto */}
          <div className="relative" data-id="element-317" data-mp="2deqw0kqovc5r">
            <Halo soft className="-left-12 -top-12 h-72 w-72 lg:h-96 lg:w-96" data-id="element-318" data-mp="2hf9ngdoo6g7f" />
            <div aria-hidden="true" className="absolute -left-4 -top-4 h-full w-full rounded-xl2 border border-lavender-200 lg:-left-6 lg:-top-6" data-id="element-319" data-mp="2hhdomnv6p140" />
            <img src={FOUNDER_IMAGE} alt="Anny, fundadora de Inkova, durante una asesoría con una clienta" loading="lazy" className="relative aspect-[4/3] w-full rounded-xl2 object-cover object-[50%_20%] shadow-lift ring-1 ring-ivory/70 sm:aspect-[4/5] lg:aspect-[3/4]" data-id="element-320" data-mp="2rb4adkzxexg0" />

            <div className="absolute -bottom-6 left-3 flex max-w-[15rem] items-start gap-3 rounded-2xl border border-lavender-200 bg-ivory/95 p-3.5 shadow-float backdrop-blur-[2px] sm:left-8 lg:-right-10 lg:bottom-12 lg:left-auto" data-id="element-321" data-mp="tx1oltyvqvmp">
              <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-pill bg-lavender-50 text-plum-700" data-id="element-322" data-mp="13xc11cd3bz0t">
                <HeartHandshakeIcon className="h-4 w-4" strokeWidth={1.6} aria-hidden="true" data-id="element-323" data-mp="1cwfkihg66gfu" />
              </span>
              <span className="leading-tight" data-id="element-324" data-mp="17xm7sr8pitgq">
                <span className="block text-[0.8rem] font-semibold text-plum-900" data-id="element-325" data-mp="17wt3ry14ui2a">
                  Acompañamiento real
                </span>
                <span className="mt-1 block text-[0.72rem] text-muted" data-id="element-326" data-mp="1hnfgnkhgsuha">De persona a persona.</span>
              </span>
            </div>
          </div>

          <div className="mt-8 lg:mt-0" data-id="element-327" data-mp="1vngeer2fnlsj">
            <RuleDot data-id="element-328" data-mp="1rlbmpxvjoz8j" />
            <h2 id="porque-titulo" className="mt-5 max-w-xl font-display text-[1.7rem] leading-[1.16] text-plum-900 sm:text-4xl lg:text-[2.6rem]" data-id="element-329" data-mp="1rm4o0jbqiwja">
              No se trata solo de abrir una LLC. Se trata de construir algo bien desde el
              comienzo.
            </h2>

            <dl className="mt-7 space-y-4 sm:mt-9 sm:space-y-6" data-id="element-330" data-mp="2185xo2thuyx1">
              {values.map(value => <div key={value.title} className="border-t border-lavender-200 pt-4 sm:pt-5" data-id="element-331" data-mp="266h566wbgxc3">
                  <dt className="flex items-center gap-3" data-id="element-332" data-mp="1rico17cwwtvf">
                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-pill border border-lavender-200 bg-ivory text-plum-700" data-id="element-333" data-mp="1w9ky85m2gj9n">
                      {value.icon}
                    </span>
                    <span className="eyebrow text-plum-700" data-id="element-334" data-mp="1mj9rkbazzvz2">{value.title}</span>
                  </dt>
                  <dd className="mt-2.5 max-w-md pl-11 text-[0.975rem] leading-relaxed text-muted sm:mt-3 sm:text-[1rem]" data-id="element-335" data-mp="18k0brcqpf3vm">
                    {value.body}
                  </dd>
                </div>)}
            </dl>

            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-analytics-id="instagram_founder" className="mt-6 inline-flex items-center gap-2 text-[0.85rem] text-muted transition-colors duration-200 ease-premium hover:text-plum-800 sm:mt-8" data-id="element-336" data-mp="2fw9cnhfe5qzk">
              <InstagramIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-337" data-mp="1x61kfud8cky5" />
              {INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>
      </div>
    </section>;
}